(function() {
  function toggleAcc(btn) {
    var body = btn.nextElementSibling;
    if (!body) return;
    var isOpen = btn.classList.contains('open');
    var parent = btn.closest('.acc') || btn.parentElement.parentElement;
    if (parent) {
      parent.querySelectorAll('.acc-btn.open').forEach(function(b) {
        if (b !== btn) {
          b.classList.remove('open');
          var bBody = b.nextElementSibling;
          if (bBody) bBody.style.maxHeight = '0';
        }
      });
    }
    btn.classList.toggle('open', !isOpen);
    body.style.maxHeight = isOpen ? '0' : (body.scrollHeight + 300) + 'px';
  }
  window.toggleAcc = toggleAcc;
})();
